import { render, staticRenderFns } from "./deleteBlockDialog.vue?vue&type=template&id=392f610a&scoped=true"
import script from "./deleteBlockDialog.vue?vue&type=script&lang=js"
export * from "./deleteBlockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392f610a",
  null
  
)

export default component.exports